import { render } from "./ReportSearch.vue?vue&type=template&id=e1d6dce2&ts=true"
import script from "./ReportSearch.vue?vue&type=script&lang=ts"
export * from "./ReportSearch.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/chooza-gift-app/chooza-gift-app/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__